// extracted by mini-css-extract-plugin
module.exports = {"Navi":"Navi_Navi__2y6zT","CustomerService":"Navi_CustomerService__32pwz","Order":"Navi_Order__3a9_a"};